import * as React from "react";
import { useEffect } from "react";

interface Chart {
  dataProvider: unknown;
  allLabels: unknown;
  validateNow(v: boolean): void;
  validateData(): void;
}

type Config = Partial<Pick<Chart, "dataProvider" | "allLabels">> & {
  listeners?: unknown[];
};

interface Amchart {
  makeChart(id: string, config: Config): Chart;
}

interface GraphProps {
  id: string;
  height?: number;
  config: Config;
}

export function Graph(props: GraphProps) {
  const { id, height, config } = props;
  const [chart, setChart] = React.useState<Chart | null>(null);

  const rendered = () => {
    const elem = document.getElementById(id);
    if (elem == null) {
      return;
    }
    const a = elem.querySelectorAll("a[href*='http://www.amcharts.com']");
    if (a) {
      for (let i = 0; i < a.length; i += 1) {
        a[i].setAttribute("rel", "noreferrer noopener");
      }
    }
  };

  useEffect(() => {
    if (config.listeners == null) {
      config.listeners = [];
    }
    config.listeners.push({
      event: "rendered",
      method: rendered,
    });
    setChart(
      (window as unknown as { [index: string]: Amchart }).AmCharts.makeChart(
        id,
        config,
      ),
    );
    rendered();
  }, []);

  useEffect(() => {
    if (!chart) {
      return;
    }
    let dataChanged = false;
    if (config.dataProvider) {
      chart.dataProvider = config.dataProvider;
      dataChanged = true;
    }
    let labelChanged = false;
    if (config.allLabels) {
      chart.allLabels = config.allLabels;
      labelChanged = true;
    }
    if (labelChanged) {
      chart.validateNow(true);
    } else if (dataChanged) {
      chart.validateData();
    }
  });

  return <div id={id} style={{ height: height != null ? height : 400 }} />;
}
